import React, { useState, useEffect } from 'react';

const DeleteModal = ({ sniperName, onConfirm, onCancel }) => {
  const [countdown, setCountdown] = useState(5);
  const [inputText, setInputText] = useState('');

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const expectedText = `DELETE ${sniperName}`;
  const isMatch = inputText === expectedText;

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>Delete Sniper</h2>
        <p>Are you sure you want to delete <strong>{sniperName}</strong>? This action cannot be undone.</p>

        {countdown > 0 ? (
          <>
            <p>Please wait <strong>{countdown}</strong> seconds before confirming.</p>
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${(countdown / 5) * 100}%` }}></div>
            </div>
          </>
        ) : (
          <>
            <p>Type <strong style={{ color: 'var(--header-primary)', fontFamily: 'Consolas, Monaco, monospace' }}>{expectedText}</strong> to confirm.</p>
            <input
              className="input-field"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              placeholder={expectedText}
              autoFocus
            />
          </>
        )}

        <div className="modal-actions">
          <button className="btn btn-gray" onClick={onCancel}>Cancel</button>
          <button
            className="btn btn-red"
            onClick={onConfirm}
            disabled={countdown > 0 || !isMatch}
          >
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
